import {
  ContentLibrarySharedFile,
  ContentLibrarySharedFiles,
} from 'features/content-library/types';
import { SHARED_FOLDER_ID } from 'features/content-library/constants';
import i18n from 'i18n';

export const normalizeSharedFiles = (sharedFiles: ContentLibrarySharedFile[]) => {
  const normalizedData: ContentLibrarySharedFiles = {
    folder: {
      id: SHARED_FOLDER_ID,
      name: i18n.t('common:shared_content_folder_name'),
      parentId: 'root',
      childFolderIds: [],
      childFileIds: [],
    },
    files: {},
  };

  for (const sharedFile of sharedFiles) {
    normalizedData.files[sharedFile.id] = sharedFile;
    normalizedData.folder.childFileIds.push(sharedFile.id);
  }

  return normalizedData;
};
